<template>
  <div id="contenedor-partidas-contables">
    <v-container fluid>
      <v-card flat class="mb-4 rounded-lg">
        <v-card-text>
          <titulo-tool-bar titulo="Catálogo de Partidas Contables" class="rounded-xl">
            <template v-slot:opciones-derecha>
              <v-btn
                color="primary"
                class="white--text"
                rounded
                @click="dialog = true"
              >
                <v-icon left>mdi-plus</v-icon>
                Agregar
              </v-btn>
            </template>
          </titulo-tool-bar>
        </v-card-text>
      </v-card>
      <v-card flat>
        <v-card-text>
          <v-data-table
            :headers="headers"
            :items="listadoPartidasContables"
            :items-per-page="5"
          >
            <template v-slot:item.acciones="{ item }">
              <v-icon
                class="mr-2"
                color="blue darken-2"
              >
                mdi-pencil
              </v-icon>
              <v-icon
                class="mr-2"
                color="red darken-2"
                @click="catalogoPartidaContableEliminar = item; showDialogEliminar = true"
              >
                mdi-delete
              </v-icon>
            </template>
            <template v-slot:no-data>
              No hay partidas contables registradas.
            </template>
          </v-data-table>
        </v-card-text>
      </v-card>
    </v-container>
    <v-dialog v-model="dialog" max-width="600px" scrollable persistent>
      <agregar-catalogo-partida-contable @close="cerrar" />
    </v-dialog>
    <v-dialog v-model="showDialogEliminar" max-width="500px" persistent>
      <v-card>
        <v-card-title class="secondary--text">
          Confirmar eliminación
          <v-spacer></v-spacer>
          <v-btn icon @click="showDialogEliminar = false">
            <v-icon class="secondary--text" large>highlight_off</v-icon>
          </v-btn>
        </v-card-title>
        <v-card-text>
          ¿Está seguro que desea eliminar la partida contable
          <strong>{{ catalogoPartidaContableEliminar.numero }}
            - {{ catalogoPartidaContableEliminar.descripcion }}</strong>?
          Esta acción no se puede deshacer.
        </v-card-text>
        <v-divider class="bkground" />
        <v-card-actions>
          <v-spacer></v-spacer>
          <custom-button
            @click="showDialogEliminar = false"
            tipo="formCancelar"
            label="Cancelar"
            class="mr-3">
          </custom-button>
          <custom-button
            @click="preEliminarCatalogoPartidaContable(catalogoPartidaContableEliminar.id)"
            tipo="formAceptar"
            label="Eliminar">
          </custom-button>
        </v-card-actions>
      </v-card>
    </v-dialog>
  </div>
</template>

<script>
import CustomButton from '@/components/buttons/Button.vue';
import TituloToolBar from '@/components/TituloToolBar.vue';
import AgregarCatalogoPartidaContable from '@/components/administracion/configuracion/catalogos/partidas.contables/Agregar.vue';
import mixCatalogoPartidasContables from '@/components/administracion/configuracion/catalogos/partidas.contables/mixCatalogoPartidasContables';

export default {
  name: 'CatalogoPartidasContablesView',
  mixins: [mixCatalogoPartidasContables],
  components: {
    TituloToolBar,
    AgregarCatalogoPartidaContable,
    CustomButton,
  },
  data() {
    return {
      dialog: false,
      showDialogEliminar: false,
      catalogoPartidaContableEliminar: {},
      headers: [
        { text: 'Número', value: 'numero' },
        { text: 'Descripción', value: 'descripcion' },
        {
          text: 'Acciones', value: 'acciones', sortable: false, width: '200px',
        },
      ],
    };
  },
  methods: {
    async preEliminarCatalogoPartidaContable(id) {
      await this.mixEliminarCatalogoPartidaContable(id).then(() => {
        this.catalogoPartidaContableEliminar = {};
        this.showDialogEliminar = false;
      });
    },
    cerrar() {
      this.dialog = false;
    },
  },
  computed: {
    listadoPartidasContables() {
      if (!this.catalogoPartidasContables) {
        return [];
      }
      return this.catalogoPartidasContables;
    },
  },
};
</script>

<style lang="scss">

</style>
